
import React, { FC, useEffect, useRef, useState } from "react";
import { FormBox } from "./FormBox"
import { TableBox } from "./TableBox"
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { AddGoodsModal } from "./AddGoodsModal";
import { HistoryModel } from "@/views/historyModel";
import { usePurchaseOfferDetailsModel } from "./purchaseOfferDetailsModel";
import { SupplierHistoryModel } from "@/views/commonModule/supplierHistoryModel"
import { FixedBottom } from "./FixedBottom";
import useGlobalModel from "@/model/globalModel";
export const PurchaseOfferDetails = () => {
    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const IFormRef = useRef<IYhFormRef>();
    const {
        historyVisible, setHistoryVisible,
        historyRow,
        supplierHistoryModel,
        detailAddForm, detailEditForm, detailLookForm,
        supplierHistoryVisible, setSupplierHistoryVisible,
    } = usePurchaseOfferDetailsModel();
    const typeForm = {
        add: detailAddForm,
        edit: detailEditForm,
        look: detailLookForm
    }
    const { user: { roles } } = useGlobalModel();

    return (
        <>
            <FormBox {...detailsInfo} IFormRef={IFormRef} />
            <TableBox {...detailsInfo} />
            {!roles.includes('hd-c' || 'hd-g') && <FixedBottom {...detailsInfo} />}
            <AddGoodsModal {...detailsInfo} />
            <HistoryModel
                visible={historyVisible}
                materialCode={historyRow.materialCode as string}
                materialName={historyRow.materialName as string}
                onCancel={() => setHistoryVisible(false)}
            />
            <SupplierHistoryModel
                visible={supplierHistoryVisible}
                name={supplierHistoryModel.supplierName}
                onCancel={() => setSupplierHistoryVisible(false)}
            />
        </>
    )
}